import type { Slicer as CoreSlicer, RewardsState } from '@ps/web-core-store';
import { models, rewardsDefaultState } from '@ps/web-core-store';
import { fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { requestStream } from '@swf/core/api/requestStream';
import type { EffectParams, ModelConfig, SelectorCreator, Slicer } from '@swf/core/store';
import { select } from '@swf/core/store';
import { logout } from '@swf/core/utils/actions';

interface RewardsModel extends ModelConfig<RewardsState> {
  reducers: typeof models.rewards.reducers;
  effects: typeof effects;
  selectors: typeof selectors;
}

const effects = {
  async fetchRewards(payload: undefined, { dispatch, rootState, actions, request }: EffectParams) {
    const options = select.cms.getRequestOptions(rootState);
    const onLogout = logout(actions) as NonNullable<ReturnType<typeof logout>>;

    requestStream<RewardsState>({
      ...options,
      service: '/api/v1-preview/cvlbar'
    })
      .pipe(takeUntil(onLogout))
      .subscribe((update) => {
        dispatch.rewards.set(update);
      });

    fromEvent(document, 'starsresume')
      .pipe(takeUntil(onLogout))
      .subscribe(async () => {
        const { body } = await request({ service: '/api/v1-preview/cvlbar' });
        dispatch.rewards.set(body);
      });
  }
};

const selectors = (slice: Slicer<RewardsState>, createSelector: SelectorCreator) => ({
  ...models.rewards.selectors(slice as CoreSlicer<RewardsState>, createSelector)
});

const rewards: RewardsModel = {
  state: rewardsDefaultState,
  reducers: models.rewards.reducers,
  effects,
  selectors
};

export default rewards;
